import script from "./UFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./UFooter.vue?vue&type=script&setup=true&lang=js"

import "./UFooter.vue?vue&type=style&index=0&id=86d6611a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d6611a"]])

export default __exports__